module.exports = __webpack_public_path__ + "img/banner1.a7a1a73a.png";